/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FoodTransactionHistoryResponsePagination
 */
export interface FoodTransactionHistoryResponsePagination {
    /**
     * Total number of food orders
     * @type {number}
     * @memberof FoodTransactionHistoryResponsePagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof FoodTransactionHistoryResponsePagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof FoodTransactionHistoryResponsePagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof FoodTransactionHistoryResponsePagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the FoodTransactionHistoryResponsePagination interface.
 */
export function instanceOfFoodTransactionHistoryResponsePagination(value: object): value is FoodTransactionHistoryResponsePagination {
    return true;
}

export function FoodTransactionHistoryResponsePaginationFromJSON(json: any): FoodTransactionHistoryResponsePagination {
    return FoodTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}

export function FoodTransactionHistoryResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FoodTransactionHistoryResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function FoodTransactionHistoryResponsePaginationToJSON(json: any): FoodTransactionHistoryResponsePagination {
    return FoodTransactionHistoryResponsePaginationToJSONTyped(json, false);
}

export function FoodTransactionHistoryResponsePaginationToJSONTyped(value?: FoodTransactionHistoryResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

